import { forwardRef, type ReactNode } from 'react';
import { EditOutlined } from '@mui/icons-material';
import { Button, type ButtonProps } from '@mui/material';

export type CompactEditButtonProps = Omit<
  ButtonProps,
  'children' | 'color' | 'endIcon' | 'fullWidth' | 'size' | 'startIcon' | 'variant'
> & {
  'aria-label': string;
  children: ReactNode;
};

/** 카드·행·검토 항목에서 보조 수정 동작을 일관되게 표시합니다. */
export const CompactEditButton = forwardRef<HTMLButtonElement, CompactEditButtonProps>(function CompactEditButton(
  { children, sx, type = 'button', ...props },
  ref,
) {
  const sxOverrides = Array.isArray(sx) ? sx : sx ? [sx] : [];

  return <Button
    {...props}
    ref={ref}
    data-compact-edit-button
    type={type}
    size="small"
    variant="weak"
    color="inherit"
    startIcon={<EditOutlined />}
    sx={[
      {
        minWidth: 0,
      },
      ...sxOverrides,
    ]}
  >{children}</Button>;
});
